/*
 * Copyright (c) Nexign, JSC, 2025.
 */
/**
 *
 *
 * @author Julia Ignatieva
 * @version 1.37.0
 * @since 1.37.0
 */

import { createSelector, OutputSelector } from 'reselect';

import { IRootReducer } from '@reducers/rootReducer';

import { IWizardChangeRoleValidation } from './types/wizardChangeRoleTypes';
import { initWizardChangeRoleState } from './wizardChangeRoleConstant';
import {
    IWizardChangeRoleOrderResult,
    IWizardChangeRoleReducer, IWizardChangeRoleSubsAccessLevel,
} from './wizardChangeRoleReducer';

export const makeSelectWizardChangeRoleState = (state: IRootReducer): IWizardChangeRoleReducer =>
    state.wizardChangeRole || initWizardChangeRoleState;

export const makeSelectWizardChangeRoleValidation = ():
    OutputSelector<IRootReducer, IWizardChangeRoleValidation,
        (state: IWizardChangeRoleReducer) => IWizardChangeRoleValidation> =>
    createSelector(makeSelectWizardChangeRoleState, state => state.validation);

export const makeSelectWizardChangeRoleSubscriberIds = ():
    OutputSelector<IRootReducer, number[],
        (state: IWizardChangeRoleReducer) => (number[])> =>
    createSelector(makeSelectWizardChangeRoleState, state => state.subscriberIds);

export const makeSelectWizardChangeRoleRemovedSubscribers = ():
    OutputSelector<IRootReducer, number[],
        (state: IWizardChangeRoleReducer) => (number[])> =>
    createSelector(makeSelectWizardChangeRoleState, state => state.removedSubscribers);

export const makeSelectWizardChangeRoleOrderResult = ():
    OutputSelector<IRootReducer, IWizardChangeRoleOrderResult,
        (state: IWizardChangeRoleReducer) => (IWizardChangeRoleOrderResult)> =>
    createSelector(makeSelectWizardChangeRoleState, state => state.orderResult);

export const makeSelectWizardChangeRoleSubsAccessLevels = ():
    OutputSelector<IRootReducer, IWizardChangeRoleSubsAccessLevel[],
        (state: IWizardChangeRoleReducer) => (IWizardChangeRoleSubsAccessLevel[])> =>
    createSelector(makeSelectWizardChangeRoleState, state => state.subsAccessLevels);

export const makeSelectWizardChangeRoleSelectedAccessLevel = ():
    OutputSelector<IRootReducer, IWizardChangeRoleSubsAccessLevel,
        (state: IWizardChangeRoleReducer) => (IWizardChangeRoleSubsAccessLevel)> =>
    createSelector(makeSelectWizardChangeRoleState, state => state.selectedAccessLevel);
